module.exports = __webpack_public_path__ + "static/media/国元证券app.8b6b96e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/国元证券app.mp4
// module id = GoTB
// module chunks = 3